/* eslint-disable */
import {
    Card,
    CardContent,
    Grid,
    RACButton,
    RACSelect,
    RACTextbox,
} from '@rentacenter/racstrap';
import React, { useContext } from 'react';
import { CostBasedPricingStyles } from '../Styles/CostBasedPricing';
import { CostBasedPricingContext } from './CostBasedPricingContext';
import { filterHierarchy, mapDropDownData } from '../../../utils/utils';

export default function CostBasedPricingFilter(props: any) {
    const classes = CostBasedPricingStyles();
    const { costBasedPricingSearchData, setCostBasedPricingSearchData,
        deptOptions, subDeptOptions, setsubDeptOptions,
        bracketOptions, setbracketOptions, zoneOptions, loader,
        dropDownData, setCostBasedPricingGridContent, searchCostBasedPricingDetails, setPageDisplay
    } = useContext(CostBasedPricingContext);

    function bindHierarchyDropDown(data: any[], filterKey: string, value: string | number, type: string) {
        const filteredData = filterHierarchy(data, filterKey, value);
        const dropDownData = mapDropDownData(filteredData, "descEn", type);
        if (type == 'subdepartmentNumber') {
            setsubDeptOptions(dropDownData)
        } else if (type == 'bracketNumber') {
            setbracketOptions(dropDownData)
        }
    }

    return (
        <Grid container md={12} style={{marginBottom: '20px'}}>
            <Card className={classes.card}>
                <CardContent>
                    <Grid container md={12} spacing={2}>
                        <Grid item md={2}>
                            <RACSelect
                                inputLabel="Zone"
                                required={true}
                                defaultValue={costBasedPricingSearchData?.zone}
                                options={zoneOptions}
                                isDisabled={true}
                            />
                        </Grid>
                        <Grid item md={2}>
                            <RACSelect
                                inputLabel="Department"
                                required={true}
                                defaultValue={costBasedPricingSearchData?.department}
                                options={deptOptions}
                                loading={loader.dropdownLoader}
                                onChange={(e) => {
                                    setCostBasedPricingSearchData({
                                        ...costBasedPricingSearchData, department: e.target.value,
                                        subdepartment: '', bracket: ''
                                    })
                                    bindHierarchyDropDown(dropDownData?.subdepartment, 'departmentNumber', e.target.value, 'subdepartmentNumber')
                                }}
                            />
                        </Grid>
                        <Grid item md={2}>
                            <RACSelect
                                inputLabel="Sub Department"
                                defaultValue={costBasedPricingSearchData?.subdepartment}
                                options={subDeptOptions}
                                isDisabled={costBasedPricingSearchData?.department ? false : true}
                                onChange={(e) => {
                                    setCostBasedPricingSearchData({ ...costBasedPricingSearchData, subdepartment: e.target.value, bracket: '' })
                                    bindHierarchyDropDown(dropDownData?.bracket, 'subdepartmentNumber', e.target.value, 'bracketNumber')
                                }}
                            />
                        </Grid>
                        <Grid item md={2}>
                            <RACSelect
                                inputLabel="Bracket"
                                defaultValue={costBasedPricingSearchData?.bracket}
                                options={bracketOptions}
                                isDisabled={(costBasedPricingSearchData?.department &&
                                    costBasedPricingSearchData?.subdepartment) ? false : true}
                                onChange={(e) => {
                                    setCostBasedPricingSearchData({ ...costBasedPricingSearchData, bracket: e.target.value })
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container md={12}>
                        <Grid item md={12}>
                            <RACButton
                                color="primary"
                                variant="contained"
                                size="small"
                                className={`${classes.floatRight}`}
                                disabled={costBasedPricingSearchData.department ? false : true}
                                onClick={() => {
                                    if (costBasedPricingSearchData.zone && costBasedPricingSearchData.department) {
                                        setCostBasedPricingGridContent([])
                                        searchCostBasedPricingDetails()
                                        setPageDisplay(0)
                                    }
                                }}
                            >
                                Apply
                            </RACButton>
                            <RACButton
                                color="primary"
                                variant="outlined"
                                size="large"
                                className={`${classes.floatRight} ${classes.mR1} ${classes.padding6}`}
                                disabled={costBasedPricingSearchData.department ? false : true}
                                onClick={() => {
                                    setCostBasedPricingSearchData({
                                        ...costBasedPricingSearchData, department: '', subdepartment: '', bracket: ''
                                    })
                                }}
                            >
                                Clear
                            </RACButton>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Grid >
    );
}
